<template>
  <div class="popup-approval">
    <b-modal
      id="popup-approval"
      ref="popup-approval"
      hide-footer
      :titleHtml="modalTitle"
      no-close-on-backdrop
      size="xl"
    >
      <Overlay
        :isLoading="isSubmitting"
        message="Đang xử lý yêu cầu..."
        noWrapMode
      />

      <ApprovalCommonData
        :mainModel="mainModel"
        :onSubmit="onSubmiting"
        v-if="renderComponent"
        v-on:submit-data="onSubmitData"
      >
      </ApprovalCommonData>

      <b-button
        ref="button"
        :disabled="isSubmitting || onSubmiting"
        style="font-weight: 600; width: 70px"
        variant="warning"
        size="sm"
        @click="onSubmit"
      >
        Lưu
        <Spinner :show="isSubmitting" custom-class="ml-2" />
      </b-button>

      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        :disabled="isSubmitting"
        @click="hideModal"
        >Hủy</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import { APPROVAL_TYPE, TIME_TRIGGER } from '@/utils/constants';
import timeUtils from '@/utils/date';
import {
  APPROVAL_ENTITY_TYPE,
  APPROVAL_PAYMENT_TYPE,
  APPROVAL_TYPE_ENUM,
} from '@/utils/enum';
import Overlay from '@/view/base/design-system/molecules/Overlay.vue';
import decounce from 'debounce';
import Spinner from '@/view/base/design-system/molecules/Spinner.vue';
import ApprovalCommonData from './ApprovalCommonData.vue';

export default {
  data() {
    return {
      mainModel: {
        id: null,
        code: '',
        paymentDate: new Date(),
        type: 1,
        status: 1,
        amount: 0,
        vatAmount: 0,
        customerId: null,
        customerName: '',
        customerMobile: '',
        customerBankName: '',
        customerBankNo: '',
        customerAccountName: '',
        entityId: null,
        entityType: 1,
        paymentType: 1,
        storeId: null,
        details: [],
      },
      dpConfigs: timeUtils.DP_CONFIG,
      editable: true,
      listType: APPROVAL_TYPE,
      filteredOptionsCustomer: [],
      optionsCustomer: [],
      modalTitle: '',
      onSubmiting: false,
      renderComponent: false,
      isSubmitting: false,
    };
  },
  components: {
    ApprovalCommonData,
    Overlay,
    Spinner,
  },
  mounted() {},
  computed: {},
  methods: {
    debounceInput: decounce(function () {
      this.getListCustomer();
    }, TIME_TRIGGER),
    onSelectCustomer(option) {
      if (option.item.id) {
        this.mainModel.customerId = option.item.id;
        this.mainModel.customerMobile = option.item.phoneNo;
        this.mainModel.customerName = option.item.fullName;
      } else {
        this.mainModel.customerId = null;
        this.mainModel.customerMobile = '';
        this.mainModel.customerName = '';
      }
    },
    onSearchChange(searchQuery) {
      if (!searchQuery) {
        searchQuery = '';
      }
      this.mainModel.customerMobile = searchQuery;
      this.optionsCustomer = [];
      this.filteredOptionsCustomer = [...this.optionsCustomer];
      this.debounceInput();
    },
    getListCustomer() {
      const text = this.mainModel.customerMobile
        ? this.mainModel.customerMobile.trim()
        : null;
      if (!text || text.length < 5) {
        return;
      }
      ApiService.get(`/v1/customers/get-by-phone?phoneNumber=${text}`).then(
        (data) => {
          this.optionsCustomer = data.data.data;
          if (this.optionsCustomer.length > 0) {
            this.filteredOptionsCustomer = [...this.optionsCustomer];
          } else {
            this.filteredOptionsCustomer = [
              { message: 'SĐT không có trong hệ thống' },
            ];
          }
        },
      );
    },
    showModal: function (entityId, data, type) {
      this.onSubmiting = false;
      this.mainModel.entityId = entityId;
      this.mainModel.entityType = this.getEnittyTypeByType(type);
      this.mainModel.amount = data.amount;
      this.mainModel.customerId = data.customerId;
      this.mainModel.customerName = data.customerName;
      this.mainModel.customerMobile = data.customerMobile;
      this.mainModel.storeId = data.storeId;
      this.mainModel.type = type;
      this.mainModel.paymentType = data.paymentType;
      this.$refs['popup-approval'].show();
      this.renderComponent = true;
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Hoàn tiền cho ID: <a class='text-primary'>#${this.mainModel.entityId}</a></span>
              </div>`;
    },
    getEnittyTypeByType(approvalType) {
      const billTypes = [
        APPROVAL_TYPE_ENUM.OVER_PAYMENT,
        APPROVAL_TYPE_ENUM.REFUND,
        APPROVAL_TYPE_ENUM.VAT,
      ];
      const orderTypes = [APPROVAL_TYPE_ENUM.DEPOSIT];
      const stockSlipTypes = [
        APPROVAL_TYPE_ENUM.BUY_OLD,
        APPROVAL_TYPE_ENUM.TRADE_IN,
      ];
      if (billTypes.includes(approvalType)) {
        return APPROVAL_ENTITY_TYPE.BILL;
      }
      if (orderTypes.includes(approvalType)) {
        return APPROVAL_ENTITY_TYPE.ORDER;
      }
      if (stockSlipTypes.includes(approvalType)) {
        return APPROVAL_ENTITY_TYPE.STOCK_SLIP;
      }
    },
    hideModal() {
      this.$refs['popup-approval'].hide();
    },
    onSubmit() {
      if (this.onSubmiting || this.isSubmitting) {
        return;
      }
      this.onSubmiting = true;
      this.isSubmitting = true;
    },
    async onSubmitData(payload) {
      if (payload.paymentType === APPROVAL_PAYMENT_TYPE.TRANSFER) {
        if (
          !payload.customerBankName.trim() ||
          !payload.customerBankNo.trim() ||
          !payload.customerAccountName.trim()
        ) {
          this.onSubmiting = false;
          this.isSubmitting = false;
          return makeToastFaile('Vui lòng nhập đầy đủ thông tin chuyển khoản!');
        }
      }
      if (!payload.approvalConfigId) {
        this.onSubmiting = false;
        this.isSubmitting = false;
        return makeToastFaile('Quy trình duyệt chi chưa được cấu hình!');
      }
      if (!payload.details.length) {
        this.onSubmiting = false;
        this.isSubmitting = false;
        return makeToastFaile('Quy trình duyệt chi không xác định bước duyệt!');
      }
      const firtStep = payload.details.find((detail) => detail.step === 1);
      if (!firtStep) {
        this.onSubmiting = false;
        this.isSubmitting = false;
        return makeToastFaile('Quy trình duyệt chi không hợp lệ!');
      }

      this.isSubmitting = true;

      try {
        const { data } = await ApiService.post('v1/approvals', payload);
        if (data.status === 200) {
          makeToastSuccess(data.message);
          this.hideModal();
          this.$emit('approval-created', data.data);
        } else {
          makeToastFaile(data.message);
        }
      } catch (err) {
        if (!err.response) {
          makeToastFaile(err.$error);
        } else {
          const message = err.response.data.message;
          makeToastFaile(message);
        }
      } finally {
        this.onSubmiting = false;
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style>
.bootstrap-datetimepicker-widget.dropdown-menu {
  width: 21em;
}
</style>
